"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _I18n = _interopRequireDefault(require("I18n"));

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var _immutable = require("immutable");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _TimelineFilterGroup = _interopRequireDefault(require("crm_ui/timeline/components/filter/TimelineFilterGroup"));

var _TimelineFilterList = _interopRequireDefault(require("crm_ui/timeline/components/filter/TimelineFilterList"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _loggers = require("customer-data-tracking/loggers");

var _colors = require("HubStyleTokens/colors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border-bottom: 1px solid ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ToggleAllUICheckbox = (0, _styledComponents.default)(_UICheckbox.default).withConfig({
  displayName: "TimelineEventsFilter__ToggleAllUICheckbox",
  componentId: "sc-1k4ggh3-0"
})(_templateObject(), _colors.BATTLESHIP);
var TimelineEventsFilter = (0, _createReactClass.default)({
  mixins: [_ComponentWithPartials.default],
  propTypes: {
    availableOptions: _propTypes.default.instanceOf(_immutable.Map),
    availableOptionsList: _propTypes.default.instanceOf(_immutable.List),
    handleOpenChange: _propTypes.default.func.isRequired,
    handlePopoverToggle: _propTypes.default.func.isRequired,
    handleUpdateTimelineFavoritedEvents: _propTypes.default.func.isRequired,
    integrationsApps: _propTypes.default.instanceOf(_immutable.List),
    isOpen: _propTypes.default.bool.isRequired,
    objectType: _propTypes.default.string.isRequired,
    timelineFavoriteEvents: _propTypes.default.instanceOf(_immutable.List)
  },
  handleToggleAllFilters: function handleToggleAllFilters(evt) {
    var availableOptionsList = this.props.availableOptionsList;
    var newEventOptions;
    evt.stopPropagation();

    if (this.isEveryFilterSelected()) {
      newEventOptions = (0, _immutable.List)();
      this.handleLogUsage('ALL', 'disabled');
    } else {
      newEventOptions = this.getOptionsWithIntegrationOptions(availableOptionsList);
      this.handleLogUsage('ALL', 'enabled');
    }

    this.props.handleUpdateTimelineFavoritedEvents(newEventOptions);
  },
  handleLogUsage: function handleLogUsage(eventType, action) {
    var objectType = this.props.objectType;

    if (objectType !== _ObjectTypes.CONTACT) {
      return;
    }

    _loggers.CrmLogger.logRecordInteraction(objectType, {
      action: "Timeline filter " + action,
      subAction: eventType
    });
  },
  handleFilterChange: function handleFilterChange(eventType, evt) {
    var timelineFavoriteEvents = this.props.timelineFavoriteEvents;
    var enabled = evt.target.checked;
    var newEventOptions;
    evt.stopPropagation();

    if (timelineFavoriteEvents.includes(eventType)) {
      if (!enabled) {
        newEventOptions = timelineFavoriteEvents.delete(timelineFavoriteEvents.indexOf(eventType));
        this.handleLogUsage(eventType, 'disabled');
      }
    } else if (enabled) {
      newEventOptions = timelineFavoriteEvents.push(eventType);
      this.handleLogUsage(eventType, 'enabled');
    }

    if (newEventOptions) {
      this.props.handleUpdateTimelineFavoritedEvents(newEventOptions);
    }
  },
  getFilteredIntegrationOptions: function getFilteredIntegrationOptions() {
    var _this$props = this.props,
        objectType = _this$props.objectType,
        integrationsApps = _this$props.integrationsApps;

    if (!integrationsApps) {
      return (0, _immutable.List)();
    }

    return integrationsApps.filter(function (option) {
      return option.get('objectTypes').includes(objectType);
    });
  },
  getOptionsWithIntegrationOptions: function getOptionsWithIntegrationOptions(options) {
    var integrationOptions = this.getFilteredIntegrationOptions().map(function (option) {
      return option.get('id');
    });
    return options.concat(integrationOptions);
  },
  getAllOptions: function getAllOptions() {
    var availableOptionsList = this.props.availableOptionsList;
    var allOptions = this.getOptionsWithIntegrationOptions(availableOptionsList);
    return (0, _immutable.Set)(allOptions);
  },
  getFavoriteOptions: function getFavoriteOptions() {
    return (0, _immutable.Set)(this.props.timelineFavoriteEvents);
  },
  getDropdownText: function getDropdownText() {
    var allOptions = this.getAllOptions();
    var favoriteOptions = this.getFavoriteOptions();
    var total = allOptions.size;
    var selected = favoriteOptions.intersect(allOptions).size;

    if (selected >= 0 && total >= 0) {
      return _react.default.createElement(_FormattedHTMLMessage.default, {
        "data-selenium-test": "timeline-filter-popover-text",
        message: "profileContentTimeline.timelineFilterDropdown",
        options: {
          selected: selected,
          total: total
        }
      });
    }

    return _I18n.default.text('profileContentTimeline.timelineFilterDropdownLoading');
  },
  isEveryFilterSelected: function isEveryFilterSelected() {
    var allOptions = this.getAllOptions();
    var favoriteOptions = this.getFavoriteOptions();
    return allOptions.size === favoriteOptions.size;
  },
  handleGroupClick: function handleGroupClick(group, evt) {
    var enabled = evt.target.checked;
    var availableOptions = this.props.availableOptions;
    var timelineFavoriteEvents = this.props.timelineFavoriteEvents;
    var newEventOptions;
    var filtersToChange;
    evt.stopPropagation();

    if (group === 'INTEGRATIONS') {
      filtersToChange = this.getFilteredIntegrationOptions().map(function (integration) {
        return integration.get('id');
      });
    } else {
      filtersToChange = availableOptions.get(group);
    }

    if (!enabled) {
      newEventOptions = timelineFavoriteEvents.toSet().subtract(filtersToChange);
      this.handleLogUsage(group, 'disabled');
    } else {
      newEventOptions = timelineFavoriteEvents.concat(filtersToChange).toSet();
      this.handleLogUsage(group, 'enabled');
    }

    this.props.handleUpdateTimelineFavoritedEvents(newEventOptions.toList());
  },
  isGroupCheckboxChecked: function isGroupCheckboxChecked(groupType) {
    var selectedCount = this.getSelectedFiltersCountByGroup(groupType);

    if (groupType === 'INTEGRATIONS') {
      var integrations = this.getFilteredIntegrationOptions();
      return selectedCount === integrations.size;
    }

    var availableOptions = this.props.availableOptions;
    return selectedCount === availableOptions.get(groupType).size;
  },
  isGroupCheckboxIndeterminate: function isGroupCheckboxIndeterminate(groupType) {
    var selectedCount = this.getSelectedFiltersCountByGroup(groupType);

    if (groupType === 'INTEGRATIONS') {
      var integrations = this.getFilteredIntegrationOptions();
      return selectedCount > 0 && selectedCount < integrations.size;
    }

    var availableOptions = this.props.availableOptions;
    return selectedCount > 0 && selectedCount < availableOptions.get(groupType).size;
  },
  getSelectedFiltersCountByGroup: function getSelectedFiltersCountByGroup(groupType) {
    var _this$props2 = this.props,
        timelineFavoriteEvents = _this$props2.timelineFavoriteEvents,
        availableOptions = _this$props2.availableOptions;
    var integrations = this.getFilteredIntegrationOptions();
    var selectedCount;

    if (groupType === 'INTEGRATIONS') {
      selectedCount = integrations.filter(function (integration) {
        return timelineFavoriteEvents.includes(integration.get('id'));
      }).size;
    } else {
      selectedCount = availableOptions.get(groupType).filter(function (eventType) {
        return timelineFavoriteEvents.includes(eventType);
      }).size;
    }

    return selectedCount;
  },
  renderCommunicationAndTeamActivity: function renderCommunicationAndTeamActivity(filters, groupType) {
    if (!filters || !filters.size) {
      return null;
    }

    return _react.default.createElement(_TimelineFilterGroup.default, {
      checked: this.isGroupCheckboxChecked(groupType),
      indeterminate: this.isGroupCheckboxIndeterminate(groupType),
      groupType: groupType,
      key: groupType,
      rightPad: 7,
      handleGroupClick: this.partial(this.handleGroupClick, groupType)
    }, _react.default.createElement(_TimelineFilterList.default, {
      className: "p-left-5",
      filters: filters,
      handleFilterChange: this.handleFilterChange,
      timelineFavoriteEvents: this.props.timelineFavoriteEvents,
      objectType: this.props.objectType
    }), _react.default.createElement(_TimelineFilterGroup.default, {
      checked: this.isGroupCheckboxChecked('TEAMACTIVITY'),
      indeterminate: this.isGroupCheckboxIndeterminate('TEAMACTIVITY'),
      groupType: 'TEAMACTIVITY',
      key: 'TEAMACTIVITY',
      rightPad: 7,
      handleGroupClick: this.partial(this.handleGroupClick, 'TEAMACTIVITY')
    }, _react.default.createElement(_TimelineFilterList.default, {
      className: "p-left-5",
      filters: this.props.availableOptions.get('TEAMACTIVITY'),
      handleFilterChange: this.handleFilterChange,
      timelineFavoriteEvents: this.props.timelineFavoriteEvents,
      objectType: this.props.objectType
    })));
  },
  renderDropdownFilterOptions: function renderDropdownFilterOptions(filters, groupType) {
    var _this$props3 = this.props,
        objectType = _this$props3.objectType,
        timelineFavoriteEvents = _this$props3.timelineFavoriteEvents;

    if (groupType === 'INTEGRATIONS') {
      return this.renderIntegrationFilters();
    }

    if (objectType === _ObjectTypes.CONTACT) {
      if (groupType === 'COMMUNICATION') {
        return this.renderCommunicationAndTeamActivity(filters, groupType);
      }

      if (groupType === 'TEAMACTIVITY') {
        return null;
      }
    }

    if (!filters || !filters.size) {
      return null;
    }

    return _react.default.createElement(_TimelineFilterGroup.default, {
      checked: this.isGroupCheckboxChecked(groupType),
      indeterminate: this.isGroupCheckboxIndeterminate(groupType),
      groupType: groupType,
      key: groupType,
      rightPad: 7,
      handleGroupClick: this.partial(this.handleGroupClick, groupType)
    }, _react.default.createElement(_TimelineFilterList.default, {
      className: "p-left-5",
      filters: filters,
      handleFilterChange: this.handleFilterChange,
      timelineFavoriteEvents: timelineFavoriteEvents,
      objectType: objectType
    }));
  },
  renderIntegrationFilters: function renderIntegrationFilters() {
    var integrations = this.getFilteredIntegrationOptions();

    if (!integrations || !integrations.size) {
      return null;
    }

    return _react.default.createElement(_TimelineFilterGroup.default, {
      checked: this.isGroupCheckboxChecked('INTEGRATIONS'),
      groupType: "INTEGRATIONS",
      handleGroupClick: this.partial(this.handleGroupClick, 'INTEGRATIONS'),
      indeterminate: this.isGroupCheckboxIndeterminate('INTEGRATIONS'),
      key: "INTEGRATIONS",
      rightPad: 2
    }, _react.default.createElement(_TimelineFilterList.default, {
      className: "p-left-5",
      filters: integrations,
      handleFilterChange: this.handleFilterChange,
      timelineFavoriteEvents: this.props.timelineFavoriteEvents,
      objectType: this.props.objectType
    }));
  },
  renderPopoverBody: function renderPopoverBody() {
    var isEveryFilterSelected = this.isEveryFilterSelected();
    var isAnyFilterSelected = this.getFavoriteOptions().size > 0;
    var availableOptions = this.props.availableOptions;
    return [_react.default.createElement(ToggleAllUICheckbox, {
      checked: isEveryFilterSelected,
      indeterminate: isAnyFilterSelected && !isEveryFilterSelected,
      className: "p-left-6 p-y-4",
      "data-selenium-test-is-selected": isEveryFilterSelected,
      "data-selenium-test": "profile-timeline-filter__toggle-all-btn",
      key: "toggleAll",
      onChange: this.handleToggleAllFilters
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "profileContentTimeline.selectAll"
    })), _react.default.createElement("div", {
      className: "display-inline-flex p-x-6 p-bottom-3 display-flex flex-wrap",
      key: "filtersContainer",
      style: {
        maxWidth: '80vw'
      }
    }, availableOptions.map(this.renderDropdownFilterOptions).toList())];
  },
  renderFilterButton: function renderFilterButton() {
    var dropdownText = this.getDropdownText();
    return _react.default.createElement("div", {
      className: "display-flex no-shrink align-center"
    }, _react.default.createElement("span", {
      className: "m-right-2",
      key: "filter-by-text"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "topbarContents.filterBy"
    })), _react.default.createElement(_UIButton.default, {
      key: "timeline-adv-filter",
      className: "m-top-0 p-x-0",
      "data-selenium-test": "profile-timeline-filter",
      onClick: this.props.handlePopoverToggle,
      use: 'transparent',
      size: 'md'
    }, dropdownText, _react.default.createElement(_UIIcon.default, {
      name: "downCarat",
      size: 10
    })));
  },
  render: function render() {
    return _react.default.createElement(_UIPopover.default, {
      arrowSize: "none",
      autoPlacement: false,
      className: "profile-timeline-filter-popover",
      closeOnOutsideClick: true,
      onOpenChange: this.props.handleOpenChange,
      open: this.props.isOpen,
      placement: "bottom right",
      content: {
        body: this.renderPopoverBody()
      }
    }, this.renderFilterButton());
  }
});
var _default = TimelineEventsFilter;
exports.default = _default;
module.exports = exports.default;